import type { GoogleCalendarConnection } from "@/types/google-calendar.types";

export function calendarMessage(connection: GoogleCalendarConnection): string {
  if (!connection.configured) return "Google Calendar is awaiting setup by your Stoop team.";
  if (connection.status === "reconnect_required") return "Reconnect Google to resume calendar sync.";
  if (connection.last_error === "invalid_google_time") {
    return "A Google time change could not be applied. The valid Stoop time was restored.";
  }
  if (connection.last_error === "sync_conflict") {
    return "An appointment changed during sync. The latest Stoop details were kept.";
  }
  if (connection.last_error) return "Sync could not finish. Your Stoop appointments are saved; we'll retry automatically.";
  if (connection.syncing) return "Syncing your calendar…";
  if (connection.status === "connected") return "Connected. Calendar changes sync automatically, usually within a minute.";
  return "Connect your main Google Calendar to keep your deals on schedule.";
}
